module.exports = __webpack_public_path__ + "img/1071545581.c9448f71.jpg";